import React from 'react';
import WorkflowCommandBar from '../../../experience/v3/WorkflowCommandBar';
import { ProjectLifecycle } from './useProjectLifecycle';

interface ProjectWorkspaceHeaderProps {
  projectId: string;
  projectName?: string;
  sourceLanguage?: string;
  targetLanguage?: string;
  status?: string;
  isIngesting?: boolean;
  lifecycle: ProjectLifecycle;
}

/** V3 — unified workflow command bar replaces stacked header chrome */
const ProjectWorkspaceHeader: React.FC<ProjectWorkspaceHeaderProps> = ({
  projectId,
  projectName,
  lifecycle,
  status,
  isIngesting,
}) => (
  <WorkflowCommandBar
    projectId={projectId}
    projectName={projectName}
    lifecycle={lifecycle}
    status={status}
    isIngesting={isIngesting}
  />
);

export default ProjectWorkspaceHeader;
